/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react-native/no-inline-styles */
import React, {  } from 'react';
import { Dimensions, Image, View } from 'react-native';
import { useSelector } from 'react-redux';

function AggrLogo() {
    const info = useSelector((state) => state.info?.info);
    return (
        <React.Fragment>
            {!!info?.aggregator_img &&
                <View style={{ alignItems: 'center', justifyContent: 'center', borderRadius: 6 }}>
                    <Image source={{ uri: info?.aggregator_img }} style={{ width: Dimensions.get('window').width / 0.8, height: 98, resizeMode: 'contain', borderRadius: 6 }} />
                </View>
            }
        </React.Fragment>
    );
}

export default AggrLogo;
